const state = {
  customize_view_dialog_visible: false,

  // default / saved / saving / not_saved / offline
  save_status: "default",
};

const mutations = {
  set_customize_view_dialog_visible(state, data) {
    state.customize_view_dialog_visible = data;
  },
  set_save_status(state, data) {
    const states = ["default", "saved", "saving", "not_saved", "offline"];

    if (!states.includes(data)) {
      state.save_status = "offline";
    } else {
      state.save_status = data;
    }
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
